import { loader } from "../../utils/assetLoader";
import { settings, returnPlatformType } from "../config";

class PlatformMaker {
    constructor(engine, app) {
        this.engine = engine;
        this.app = app;
    }

    // -----------------------------------------------------------------------
    // --------------------------------- [ Analysing the platform data ] -----
    make(platform, x, groundY) {
        const container = new PIXI.Container();
        this.app.stage.addChild(container);
        container.x = x;
        container.y = groundY;

        // this.createPlatformElements(elem, container, type);
        const data = this.createElem(platform.name, container.x, container.y);
        container.addChild(data.tile);

        const pickupData = [];
        if(platform.pickups) {
            platform.pickups.forEach(pickup => {
                const data = this.createPickup(
                    pickup, 
                    container.x + pickup.x, 
                    container.y - pickup.y
                );

                container.addChild(data.tile);
                pickupData.push(data)
            });
        }

        const systemData = [];
        if (platform.systems) {
            platform.systems.forEach(system => {
                let data;
                if(system.name === "boss") {
                    data = this.createEnd(
                        system,
                        container.x + system.x, 
                        container.y - system.y
                    )
                    data.tiles.forEach(tile => container.addChild(tile));
                }
                else {
                    data = this.createSystem(
                        system,
                        container.x + system.x, 
                        container.y - system.y
                    );
                }
                
                if(data) {
                    systemData.push(data);
                }
            })
        }
        

        const gameObject = {
            container,
            tile: data.tile,
            body: data.body,
            type: returnPlatformType(platform.name).type,
            width: data.width
        }

        return [gameObject, pickupData, systemData];
    }

    
    // -----------------------------------------------------------------------
    // --------------------------------- [ Creating the actual elements ] ----
        
    // --------- base constructor for everything
    createElem(elem, posX, posY) {
        const type = returnPlatformType(elem).type;
        const tile = loader.Sprite(elem);
        let [width, height] = [tile.width, tile.height];
        
        if(elem.includes("ground")) {
            // this is cos ground sprites have a little lip to each end of it that we want to ignore
            const offset = settings.groundPlatformsOffset;
            tile.position.set(offset, 0);
            width += offset * 2;
        }

        // I'm really not using this label properly, but I really should've from the beginning
        // There's so much spaghetti code... Help...
        let label = "everything";
        if(type === "platform") {
            label = elem.includes("ground") ? "ground" : "floater";
        } else if(type === "pickups") {
            if(elem.name === "item_milk" || elem.name === "item_spoon") {
                label = "pickup-multiply";
            } else {
                label = "pickup-add";
            }
        } else {
            label = type;
        }

        const body = Matter.Bodies.rectangle(
            width / 2 + posX,  // setting the initial xpos for the center of the rectangle
            height / 2 + posY, // setting the initial ypos for the center of the rectangle
            width, 
            height, 
            type === "platform" ? 
                {friction: 0, isStatic: true, label: label}:
                {isSensor: true, isStatic: true, label: label}
        )
        
        Matter.World.add(this.engine.world, body)
        
        return {
            tile,
            type,
            body, 
            width
        }
    }

        // --------- pickup maker
        createPickup(pickup, posX, posY) {
            const data = this.createElem(pickup.name, posX, posY);
            data.tile.position.set(pickup.x, -pickup.y);
            let destroyed = false;
            let effect;
            if(pickup.name === "item_milk" || pickup.name === "item_spoon") {
                effect = "multiply";
            } else {
                effect = "add";
            }
            return {
                tile: data.tile,
                body: data.body,
                effect,
                destroy: () => {
                    if(destroyed) return;
                    // this isn't working idk why, will worry about it later
                    // Matter.World.remove(this.engine.world, data.body);
                    data.tile.destroy();
                    destroyed = true;
                },
            };
        } 
        // --------- system maker
        createSystem(system, posX, posY) {
            let [width, height] = [system.width, system.height];
            
            const body = Matter.Bodies.rectangle(
                width / 2 + posX,  // setting the initial xpos for the center of the rectangle
                -height / 2 + posY, // setting the initial ypos for the center of the rectangle
                width, 
                height, 
                system.name.includes("Trig") ? 
                    {isSensor: true, isStatic: true}:
                    {friction: 0, isStatic: true}
            )
            Matter.World.add(this.engine.world, body)
            
            return {
                name: system.name,
                body: body,
                destroy: () => {
                    Matter.World.remove(this.engine.world, body);
                }
            };
        }

        createEnd(system, posX, posY) {
            // Create tower
            const sequence = [
                "endBowl",
                ["endBlock", "endBlockHole", "endSpoon1", ], //endspoon1
                ["endBlock", "endBlockHole", "endSpoon2", ], //endspoon2
                ["endBlock", "endBlockHole", "endSpoon3", ], //endspoon3
                ["endBlock", "endBlockHole", "endSpoon4", ], //endspoon4
                ["endBlock", "endBlockHole", "endSpoon5", ], //endspoon5
            ];
            
            let width = 0, height = 0;
            
            let tileBin = [];
            let spoons = [];
            // log continuous height of tower
            sequence.forEach(entity => {
                if(entity === "endBowl") {
                    const tile = loader.Sprite(entity);
                    height += tile.height;
                    tile.position.set(system.x - tile.width / 2, -system.y - height);
                    width = tile.width / 2;
                    tileBin.push(tile);
                } 
                else {
                    const tiles = entity;
                    const tile1 = loader.Sprite(tiles[0]);
                    height += tile1.height;
                    tile1.position.set(system.x - tile1.width / 2, -system.y - height);
                    tileBin.push(tile1);
                    
                    const tile2 = loader.Sprite(tiles[1]);
                    height += tile2.height;
                    tile2.position.set(system.x - tile2.width / 2, -system.y - height);
                    tileBin.push(tile2);
                    
                    const tile3 = loader.Sprite(tiles[2]);
                    tile3.position.set(system.x - tile3.width / 2, -system.y - height);
                    tileBin.push(tile3);
                    spoons += tile3;
                }
            })


            // Create body based on height
            const body = Matter.Bodies.rectangle(
                width / 2 + posX,  // setting the initial xpos for the center of the rectangle
                -height / 2 + posY, // setting the initial ypos for the center of the rectangle
                width, 
                height, 
                {isSensor: true, isStatic: true}
            )
            
            Matter.World.add(this.engine.world, body)     
            return {
                tiles: tileBin,
                name: "boss",
                body: body,
                yCoords: [posY, height],
                destroy: (duration, threshold) => {
                    // Does a breaking down animation
                    let spoonIndex = threshold;
                    console.log(spoonIndex);
                    let maxSteps = duration/5;
                    tileBin.forEach((tile, index) => {
                        let rand = Math.random();
                        const [startX, startY] = [tile.x, tile.y]
                        const [finalX, finalY] = [
                            tile.x + (rand * 300 - 100) * 2,
                            tile.y + (rand * 100 - 33) * 2,
                        ]
                        const randRot = rand * 7 - 3.5;
            
                        let steps = maxSteps;
                        const interval = window.setInterval(() => {
                            steps--;
                            if (steps > 0) {
                                tile.alpha -= 1/steps;
                                if(index !== 0) {
                                    let t = 1 - (steps/maxSteps);
            
                                    const x = startX + (finalX - startX) * t;
                                    // const y = startY + (finalY - startY) * t;
                                    const y = 500 * t * (t - 1) + startY + (finalY - startY) * t;
            
                                    tile.x = x;
                                    tile.y = y;
                                    tile.rotation = randRot * t;
                                    // console.log("tick: ", t);
                                }
                            } else if (steps === 0) {
                                
                            } else {
                                clearInterval(interval);
                                // tileBin.forEach(tile => tile.destroy())
                            }
                        }, 5);
                    })


                },
            }
        }

}

export default PlatformMaker;